import { Countries } from './country.model';

export const countries_en: Countries [] = [
    { name: 'Afghanistan' },
    { name: 'Albania' },
    { name: 'Algeria' },
    { name: 'American Samoa' },
    { name: 'Andorra' },
    { name: 'Angola' },
    { name: 'Anguilla' },
    { name: 'Antarctica' },
    { name: 'Antigua and Barbuda' },
    { name: 'Argentina' },
    { name: 'Armenia' },
    { name: 'Aruba' },
    { name: 'Australia' },
    { name: 'Austria' },
    { name: 'Azerbaijan' },
    { name: 'Åland Islands' },
    { name: 'Bahamas' },
    { name: 'Bahrain' },
    { name: 'Bangladesh' },
    { name: 'Barbados' },
    { name: 'Belarus' },
    { name: 'Belgium' },
    { name: 'Belize' },
    { name: 'Benin' },
    { name: 'Bermuda' },
    { name: 'Bhutan' },
    { name: 'Bolivia' },
    { name: 'Bonaire, Sint Eustatius and Saba' },
    { name: 'Bosnia and Herzegovina' },
    { name: 'Botswana' },
    { name: 'Bouvet Island' },
    { name: 'Brazil' },
    { name: 'British Indian Ocean Territory' },
    { name: 'Brunei Darussalam' },
    { name: 'Bulgaria' },
    { name: 'Burkina Faso' },
    { name: 'Burundi' },
    { name: 'Cabo Verde' },
    { name: 'Cambodia' },
    { name: 'Cameroon' },
    { name: 'Canada' },
    { name: 'Cayman Islands' },
    { name: 'Central African Republic' },
    { name: 'Chad' },
    { name: 'Chile' },
    { name: 'China' },
    { name: 'Christmas Island' },
    { name: 'Cocos Islands' },
    { name: 'Colombia' },
    { name: 'Comoros' },
    { name: 'Congo' },
    { name: 'Cook Islands' },
    { name: 'Costa Rica' },
    { name: 'Croatia' },
    { name: 'Cuba' },
    { name: 'Curaçao' },
    { name: 'Cyprus' },
    { name: 'Czechia' },
    { name: 'Côte d\'Ivoire' },
    { name: 'Denmark' },
    { name: 'Djibouti' },
    { name: 'Dominica' },
    { name: 'Dominican Republic' },
    { name: 'Ecuador' },
    { name: 'Egypt' },
    { name: 'El Salvador' },
    { name: 'Equatorial Guinea' },
    { name: 'Eritrea' },
    { name: 'Estonia' },
    { name: 'Eswatini' },
    { name: 'Ethiopia' },
    { name: 'Falkland Islands' },
    { name: 'Faroe Islands' },
    { name: 'Fiji' },
    { name: 'Finland' },
    { name: 'France' },
    { name: 'French Guiana' },
    { name: 'French Polynesia' },
    { name: 'French Southern Territories' },
    { name: 'Gabon' },
    { name: 'Gambia' },
    { name: 'Georgia' },
    { name: 'Germany' },
    { name: 'Ghana' },
    { name: 'Gibraltar' },
    { name: 'Greece' },
    { name: 'Greenland' },
    { name: 'Grenada' },
    { name: 'Guadeloupe' },
    { name: 'Guam' },
    { name: 'Guatemala' },
    { name: 'Guernsey' },
    { name: 'Guinea' },
    { name: 'Guinea-Bissau' },
    { name: 'Guyana' },
    { name: 'Haiti' },
    { name: 'Heard Island and McDonald Islands' },
    { name: 'Holy See' },
    { name: 'Honduras' },
    { name: 'Hong Kong' },
    { name: 'Hungary' },
    { name: 'Iceland' },
    { name: 'India' },
    { name: 'Indonesia' },
    { name: 'Iran' },
    { name: 'Iraq' },
    { name: 'Ireland' },
    { name: 'Isle of Man' },
    { name: 'Israel' },
    { name: 'Italy' },
    { name: 'Jamaica' },
    { name: 'Japan' },
    { name: 'Jersey' },
    { name: 'Jordan' },
    { name: 'Kazakhstan' },
    { name: 'Kenya' },
    { name: 'Kiribati' },
    { name: 'Korea' },
    { name: 'Korea (Republic of)' },
    { name: 'Kuwait' },
    { name: 'Kyrgyzstan' },
    { name: 'Lao People\'s Democratic Republic' },
    { name: 'Latvia' },
    { name: 'Lebanon' },
    { name: 'Lesotho' },
    { name: 'Liberia' },
    { name: 'Libya' },
    { name: 'Liechtenstein' },
    { name: 'Lithuania' },
    { name: 'Luxembourg' },
    { name: 'Macao' },
    { name: 'Madagascar' },
    { name: 'Malawi' },
    { name: 'Malaysia' },
    { name: 'Maldives' },
    { name: 'Mali' },
    { name: 'Malta' },
    { name: 'Marshall Islands' },
    { name: 'Martinique' },
    { name: 'Mauritania' },
    { name: 'Mauritius' },
    { name: 'Mayotte' },
    { name: 'Mexico' },
    { name: 'Micronesia' },
    { name: 'Moldova' },
    { name: 'Monaco' },
    { name: 'Mongolia' },
    { name: 'Montenegro' },
    { name: 'Montserrat' },
    { name: 'Morocco' },
    { name: 'Mozambique' },
    { name: 'Myanmar' },
    { name: 'Namibia' },
    { name: 'Nauru' },
    { name: 'Nepal' },
    { name: 'Netherlands' },
    { name: 'New Caledonia' },
    { name: 'New Zealand' },
    { name: 'Nicaragua' },
    { name: 'Nigeria' },
    { name: 'Niue' },
    { name: 'Norfolk Island' },
    { name: 'Northern Mariana Islands' },
    { name: 'Norway' },
    { name: 'Oman' },
    { name: 'Pakistan' },
    { name: 'Palau' },
    { name: 'Palestine' },
    { name: 'Panama' },
    { name: 'Papua New Guinea' },
    { name: 'Paraguay' },
    { name: 'Peru' },
    { name: 'Philippines' },
    { name: 'Pitcairn' },
    { name: 'Poland' },
    { name: 'Puerto Rico' },
    { name: 'Qatar' },
    { name: 'Republic of North Macedonia' },
    { name: 'Romania' },
    { name: 'Russia' },
    { name: 'Rwanda' },
    { name: 'Réunion' },
    { name: 'Saint Barthélemy' },
    { name: 'Saint Helena, Ascension and Tristan da Cunha' },
    { name: 'Saint Kitts and Nevis' },
    { name: 'Saint Lucia' },
    { name: 'Saint Martin' },
    { name: 'Saint Pierre and Miquelon' },
    { name: 'Saint Vincent and the Grenadines' },
    { name: 'Samoa' },
    { name: 'San Marino' },
    { name: 'Sao Tome and Principe' },
    { name: 'Saudi Arabia' },
    { name: 'Senegal' },
    { name: 'Serbia' },
    { name: 'Seychelles' },
    { name: 'Sierra Leone' },
    { name: 'Singapore' },
    { name: 'Sint Maarten' },
    { name: 'Slovakia' },
    { name: 'Slovenia' },
    { name: 'Solomon Islands' },
    { name: 'Somalia' },
    { name: 'South Africa' },
    { name: 'South Georgia and the South Sandwich Islands' },
    { name: 'South Sudan' },
    { name: 'Spain' },
    { name: 'Sri Lanka' },
    { name: 'Sudan' },
    { name: 'Suriname' },
    { name: 'Svalbard and Jan Mayen' },
    { name: 'Sweden' },
    { name: 'Switzerland' },
    { name: 'Syrian Arab Republic' },
    { name: 'Taiwan' },
    { name: 'Tajikistan' },
    { name: 'Tanzania, United Republic of' },
    { name: 'Thailand' },
    { name: 'Timor-Leste' },
    { name: 'Togo' },
    { name: 'Tokelau' },
    { name: 'Tonga' },
    { name: 'Trinidad and Tobago' },
    { name: 'Tunisia' },
    { name: 'Turkey' },
    { name: 'Turkmenistan' },
    { name: 'Turks and Caicos Islands' },
    { name: 'Tuvalu' },
    { name: 'Uganda' },
    { name: 'Ukraine' },
    { name: 'United Arab Emirates' },
    { name: 'Northern Ireland' },
    { name: 'United States of America' },
    { name: 'Uruguay' },
    { name: 'Uzbekistan' },
    { name: 'Vanuatu' },
    { name: 'Venezuela' },
    { name: 'Vietnam' },
    { name: 'Virgin Islands' },
    { name: 'Wallis and Futuna' },
    { name: 'Western Sahara' },
    { name: 'Yemen' },
    { name: 'Zambia' },
    { name: 'Zimbabwe' }
];

export const countries_pt: Countries [] = [
    { name: 'Afeganistão' },
    { name: 'África do Sul' },
    { name: 'Albânia' },
    { name: 'Alemanha' },
    { name: 'Andorra' },
    { name: 'Angola' },
    { name: 'Anguilla' },
    { name: 'Antárctica' },
    { name: 'Antígua e Barbuda' },
    { name: 'Arábia Saudita' },
    { name: 'Argélia' },
    { name: 'Argentina' },
    { name: 'Arménia' },
    { name: 'Aruba' },
    { name: 'Austrália' },
    { name: 'Áustria' },
    { name: 'Azerbaijão' },
    { name: 'Bahamas' },
    { name: 'Bahrein' },
    { name: 'Bangladesh' },
    { name: 'Barbados' },
    { name: 'Bélgica' },
    { name: 'Belize' },
    { name: 'Benin' },
    { name: 'Bermudas' },
    { name: 'Bielorrússia' },
    { name: 'Bolívia' },
    { name: 'Bonaire, Sint Eustatius e Saba' },
    { name: 'Bósnia e Herzegovina' },
    { name: 'Botswana' },
    { name: 'Brasil' },
    { name: 'Brunei Darussalam' },
    { name: 'Bulgária' },
    { name: 'Burkina Faso' },
    { name: 'Burundi' },
    { name: 'Butão' },
    { name: 'Cabo Verde' },
    { name: 'Camarões' },
    { name: 'Camboja' },
    { name: 'Canadá' },
    { name: 'Cazaquistão' },
    { name: 'Chad' },
    { name: 'Chile' },
    { name: 'China' },
    { name: 'Chipre' },
    { name: 'Colômbia' },
    { name: 'Comores' },
    { name: 'Congo' },
    { name: 'Coreia (República da)' },
    { name: 'Coreia' },
    { name: 'Costa Rica' },
    { name: 'Côte d\'Ivoire' },
    { name: 'Croácia' },
    { name: 'Cuba' },
    { name: 'Curaçao' },
    { name: 'Czechia' },
    { name: 'Dinamarca' },
    { name: 'Djibouti' },
    { name: 'Dominica' },
    { name: 'Egipto' },
    { name: 'El Salvador' },
    { name: 'Emiratos Árabes Unidos' },
    { name: 'Equador' },
    { name: 'Eritreia' },
    { name: 'Eslováquia' },
    { name: 'Eslovénia' },
    { name: 'Espanha' },
    { name: 'Estados Unidos da América' },
    { name: 'Estónia' },
    { name: 'Eswatini' },
    { name: 'Etiópia' },
    { name: 'Fiji' },
    { name: 'Filipinas' },
    { name: 'Finlândia' },
    { name: 'França' },
    { name: 'Gabão' },
    { name: 'Gâmbia' },
    { name: 'Gana' },
    { name: 'Geórgia do Sul e as Ilhas Sandwich do Sul' },
    { name: 'Geórgia' },
    { name: 'Gibraltar' },
    { name: 'Grécia' },
    { name: 'Grenada' },
    { name: 'Gronelândia' },
    { name: 'Guadalupe' },
    { name: 'Guam' },
    { name: 'Guatemala' },
    { name: 'Guernsey' },
    { name: 'Guiana Francesa' },
    { name: 'Guiana' },
    { name: 'Guiné Equatorial' },
    { name: 'Guiné-Bissau' },
    { name: 'Guiné' },
    { name: 'Haiti' },
    { name: 'Heard Island and McDonald Islands' },
    { name: 'Honduras' },
    { name: 'Hong Kong' },
    { name: 'Hungria' },
    { name: 'Iémen' },
    { name: 'Ilha Bouvet' },
    { name: 'Ilha de Homem' },
    { name: 'Ilha de Natal' },
    { name: 'Ilha Norfolk' },
    { name: 'Ilhas Åland' },
    { name: 'Ilhas Caimão' },
    { name: 'Ilhas Cocos' },
    { name: 'Ilhas Cook' },
    { name: 'Ilhas Faroe' },
    { name: 'Ilhas Malvinas' },
    { name: 'Ilhas Marianas do Norte' },
    { name: 'Ilhas Marshall' },
    { name: 'Ilhas Salomão' },
    { name: 'Ilhas Turcas e Caicos' },
    { name: 'Ilhas Virgens' },
    { name: 'Índia' },
    { name: 'Indonésia' },
    { name: 'Irão' },
    { name: 'Iraque' },
    { name: 'Irlanda do Norte' },
    { name: 'Irlanda' },
    { name: 'Islândia' },
    { name: 'Israel' },
    { name: 'Itália' },
    { name: 'Jamaica' },
    { name: 'Japão' },
    { name: 'Jersey' },
    { name: 'Jordan' },
    { name: 'Kiribati' },
    { name: 'Kuwait' },
    { name: 'Lesotho' },
    { name: 'Letónia' },
    { name: 'Líbano' },
    { name: 'Libéria' },
    { name: 'Líbia' },
    { name: 'Liechtenstein' },
    { name: 'Lituânia' },
    { name: 'Luxemburgo' },
    { name: 'Macau' },
    { name: 'Madagáscar' },
    { name: 'Malásia' },
    { name: 'Malawi' },
    { name: 'Maldivas' },
    { name: 'Mali' },
    { name: 'Malta' },
    { name: 'Marrocos' },
    { name: 'Martinica' },
    { name: 'Mauritânia' },
    { name: 'Mauritius' },
    { name: 'Mayotte' },
    { name: 'México' },
    { name: 'Micronésia' },
    { name: 'Moçambique' },
    { name: 'Moldávia' },
    { name: 'Mónaco' },
    { name: 'Mongólia' },
    { name: 'Montenegro' },
    { name: 'Montserrat' },
    { name: 'Myanmar' },
    { name: 'Namíbia' },
    { name: 'Nauru' },
    { name: 'Nepal' },
    { name: 'Nicarágua' },
    { name: 'Nigéria' },
    { name: 'Niue' },
    { name: 'Noruega' },
    { name: 'Nova Caledónia' },
    { name: 'Nova Zelândia' },
    { name: 'Oman' },
    { name: 'Países Baixos' },
    { name: 'Palau' },
    { name: 'Palestina' },
    { name: 'Panamá' },
    { name: 'Papua Nova Guiné' },
    { name: 'Paquistão' },
    { name: 'Paraguai' },
    { name: 'Peru' },
    { name: 'Pitcairn' },
    { name: 'Polinésia Francesa' },
    { name: 'Polónia' },
    { name: 'Porto Rico' },
    { name: 'Qatar' },
    { name: 'Quénia' },
    { name: 'Quirguizistão' },
    { name: 'República Árabe da Síria' },
    { name: 'República Centro-Africana' },
    { name: 'República da Macedónia do Norte' },
    { name: 'República Democrática Popular do Laos' },
    { name: 'República Dominicana' },
    { name: 'Reunião' },
    { name: 'Roménia' },
    { name: 'Ruanda' },
    { name: 'Rússia' },
    { name: 'Sahara Ocidental' },
    { name: 'Saint Barthélemy' },
    { name: 'Samoa Americana' },
    { name: 'Samoa' },
    { name: 'San Marino' },
    { name: 'Santa Helena, Ascensão e Tristão da Cunha' },
    { name: 'Santa Lúcia' },
    { name: 'Santa Sé' },
    { name: 'São Cristóvão e Nevis' },
    { name: 'São Martinho' },
    { name: 'São Pedro e Miquelon' },
    { name: 'São Tomé e Príncipe' },
    { name: 'São Vicente e as Granadinas' },
    { name: 'Senegal' },
    { name: 'Serra Leoa' },
    { name: 'Sérvia' },
    { name: 'Seychelles' },
    { name: 'Singapura' },
    { name: 'Sint Maarten' },
    { name: 'Somália' },
    { name: 'Sri Lanka' },
    { name: 'Sudão' },
    { name: 'Suécia' },
    { name: 'Suíça' },
    { name: 'Sul do Sudão' },
    { name: 'Suriname' },
    { name: 'Svalbard e Jan Mayen' },
    { name: 'Tailândia' },
    { name: 'Taiwan' },
    { name: 'Tajiquistão' },
    { name: 'Tanzânia, República Unida da' },
    { name: 'Território Britânico do Oceano Índico' },
    { name: 'Territórios Franceses do Sul' },
    { name: 'Timor-Leste' },
    { name: 'Togo' },
    { name: 'Tokelau' },
    { name: 'Tonga' },
    { name: 'Trinidad e Tobago' },
    { name: 'Tunísia' },
    { name: 'Turquemenistão' },
    { name: 'Turquia' },
    { name: 'Tuvalu' },
    { name: 'Ucrânia' },
    { name: 'Uganda' },
    { name: 'Uruguai' },
    { name: 'Uzbequistão' },
    { name: 'Vanuatu' },
    { name: 'Venezuela' },
    { name: 'Vietname' },
    { name: 'Wallis e Futuna' },
    { name: 'Zâmbia' },
    { name: 'Zimbabwe' }
];

export const countries_es: Countries [] = [
    { name: 'Alemania' },
    { name: 'Arabia Saudí' },
    { name: 'Azerbaiyán' },
    { name: 'Bahamas' },
    { name: 'Bahrain' },
    { name: 'Bangladesh' },
    { name: 'Barbados' },
    { name: 'Bélgica' },
    { name: 'Belice' },
    { name: 'Benin' },
    { name: 'Bermudas' },
    { name: 'Bielorrusia' },
    { name: 'Bolivia' },
    { name: 'Bonaire, San Eustaquio y Saba' },
    { name: 'Bosnia y Herzegovina' },
    { name: 'Botsuana' },
    { name: 'Brasil' },
    { name: 'Brunei Darussalam' },
    { name: 'Bulgaria' },
    { name: 'Burkina Faso' },
    { name: 'Burundi' },
    { name: 'Bután' },
    { name: 'Cabo Verde' },
    { name: 'Camboya' },
    { name: 'Camerún' },
    { name: 'Canadá' },
    { name: 'Chad' },
    { name: 'Chile' },
    { name: 'China' },
    { name: 'Chipre' },
    { name: 'Colombia' },
    { name: 'Comoras' },
    { name: 'Congo' },
    { name: 'Corea (República de)' },
    { name: 'Corea' },
    { name: 'Costa Rica' },
    { name: 'Costa de Marfil' },
    { name: 'Croacia' },
    { name: 'Cuba' },
    { name: 'Curaçao' },
    { name: 'Czechia' },
    { name: 'Dinamarca' },
    { name: 'Djibouti' },
    { name: 'Dominica' },
    { name: 'Ecuador' },
    { name: 'Egipto' },
    { name: 'El Salvador' },
    { name: 'Emiratos Árabes Unidos' },
    { name: 'Eritrea' },
    { name: 'Eslovaquia' },
    { name: 'Eslovenia' },
    { name: 'España' },
    { name: 'Estados Unidos de América' },
    { name: 'Estonia' },
    { name: 'Eswatini' },
    { name: 'Etiopía' },
    { name: 'Falkland Islands' },
    { name: 'Fiji' },
    { name: 'Filipinas' },
    { name: 'Finlandia' },
    { name: 'Francia' },
    { name: 'Gabón' },
    { name: 'Gambia' },
    { name: 'Georgia del Sur y las Islas Sandwich del Sur' },
    { name: 'Georgia' },
    { name: 'Ghana' },
    { name: 'Gibraltar' },
    { name: 'Granada' },
    { name: 'Grecia' },
    { name: 'Groenlandia' },
    { name: 'Guadalupe' },
    { name: 'Guam' },
    { name: 'Guatemala' },
    { name: 'Guayana Francesa' },
    { name: 'Guernsey' },
    { name: 'Guinea Ecuatorial' },
    { name: 'Guinea-Bissau' },
    { name: 'Guinea' },
    { name: 'Guyana' },
    { name: 'Haití' },
    { name: 'Honduras' },
    { name: 'Hong Kong' },
    { name: 'Hungría' },
    { name: 'India' },
    { name: 'Indonesia' },
    { name: 'Irán' },
    { name: 'Iraq' },
    { name: 'Irlanda del Norte' },
    { name: 'Irlanda' },
    { name: 'Isla Bouvet' },
    { name: 'Isla de Man' },
    { name: 'Isla de Navidad' },
    { name: 'Isla de Norfolk' },
    { name: 'Isla Heard e Islas McDonald' },
    { name: 'Islandia' },
    { name: 'Islas Åland' },
    { name: 'Islas Caimán' },
    { name: 'Islas Cocos' },
    { name: 'Islas Cook' },
    { name: 'Islas Feroe' },
    { name: 'Islas Marianas del Norte' },
    { name: 'Islas Marshall' },
    { name: 'Islas Salomón' },
    { name: 'Islas Turcas y Caicos' },
    { name: 'Islas Vírgenes' },
    { name: 'Israel' },
    { name: 'Italia' },
    { name: 'Jamaica' },
    { name: 'Japón' },
    { name: 'Jersey' },
    { name: 'Jordania' },
    { name: 'Kazajistán' },
    { name: 'Kenia' },
    { name: 'Kirguistán' },
    { name: 'Kiribati' },
    { name: 'Kuwait' },
    { name: 'Lesotho' },
    { name: 'Letonia' },
    { name: 'Líbano' },
    { name: 'Liberia' },
    { name: 'Libia' },
    { name: 'Liechtenstein' },
    { name: 'Lituania' },
    { name: 'Luxemburgo' },
    { name: 'Macao' },
    { name: 'Madagascar' },
    { name: 'Malasia' },
    { name: 'Malawi' },
    { name: 'Maldivas' },
    { name: 'Mali' },
    { name: 'Malta' },
    { name: 'Marruecos' },
    { name: 'Martinica' },
    { name: 'Mauricio' },
    { name: 'Mauritania' },
    { name: 'Mayotte' },
    { name: 'México' },
    { name: 'Micronesia' },
    { name: 'Moldavia' },
    { name: 'Mónaco' },
    { name: 'Mongolia' },
    { name: 'Montenegro' },
    { name: 'Montserrat' },
    { name: 'Mozambique' },
    { name: 'Myanmar' },
    { name: 'Namibia' },
    { name: 'Nauru' },
    { name: 'Nepal' },
    { name: 'Nicaragua' },
    { name: 'Nigeria' },
    { name: 'Niue' },
    { name: 'Noruega' },
    { name: 'Nueva Caledonia' },
    { name: 'Nueva Zelanda' },
    { name: 'Omán' },
    { name: 'Países Bajos' },
    { name: 'Pakistán' },
    { name: 'Palau' },
    { name: 'Palestina' },
    { name: 'Panamá' },
    { name: 'Papúa Nueva Guinea' },
    { name: 'Paraguay' },
    { name: 'Perú' },
    { name: 'Pitcairn' },
    { name: 'Polinesia Francesa' },
    { name: 'Polonia' },
    { name: 'Puerto Rico' },
    { name: 'Qatar' },
    { name: 'República Árabe Siria' },
    { name: 'República Centroafricana' },
    { name: 'República de Macedonia del Norte' },
    { name: 'República Democrática Popular de Laos' },
    { name: 'República Dominicana' },
    { name: 'Réunion' },
    { name: 'Ruanda' },
    { name: 'Rumanía' },
    { name: 'Rusia' },
    { name: 'Sahara Occidental' },
    { name: 'Samoa' },
    { name: 'San Bartolomé' },
    { name: 'San Cristóbal y Nieves' },
    { name: 'San Marino' },
    { name: 'San Martín' },
    { name: 'San Pedro y Miquelón' },
    { name: 'San Vicente y las Granadinas' },
    { name: 'Santa Elena, Ascensión y Tristán da Cunha' },
    { name: 'Santa Lucía' },
    { name: 'Santa Sede' },
    { name: 'Santo Tomé y Príncipe' },
    { name: 'Senegal' },
    { name: 'Serbia' },
    { name: 'Seychelles' },
    { name: 'Sierra Leona' },
    { name: 'Singapur' },
    { name: 'Sint Maarten' },
    { name: 'Somalia' },
    { name: 'Sri Lanka' },
    { name: 'Sudáfrica' },
    { name: 'Sudán del Sur' },
    { name: 'Sudán' },
    { name: 'Suecia' },
    { name: 'Suiza' },
    { name: 'Surinam' },
    { name: 'Svalbard y Jan Mayen' },
    { name: 'Tailandia' },
    { name: 'Taiwán' },
    { name: 'Tanzania, República Unida de' },
    { name: 'Tayikistán' },
    { name: 'Territorio Británico del Océano Índico' },
    { name: 'Territorios Australes Franceses' },
    { name: 'Timor-Leste' },
    { name: 'Togo' },
    { name: 'Tokelau' },
    { name: 'Tonga' },
    { name: 'Trinidad y Tobago' },
    { name: 'Túnez' },
    { name: 'Turkmenistán' },
    { name: 'Turquía' },
    { name: 'Tuvalu' },
    { name: 'Ucrania' },
    { name: 'Uganda' },
    { name: 'Uruguay' },
    { name: 'Uzbekistán' },
    { name: 'Vanuatu' },
    { name: 'Venezuela' },
    { name: 'Vietnam' },
    { name: 'Wallis y Futuna' },
    { name: 'Yemen' },
    { name: 'Zambia' },
    { name: 'Zimbabue' }
];

export const countries_pt_fixed: Countries [] = [
    { name: 'Portugal' }
];

// for invoice express form (payment)
export const countries_en_payment: Countries [] = [
    { name: 'Afghanistan', value: 'Afghanistan' },
    { name: 'Albania', value: 'Albania' },
    { name: 'Algeria', value: 'Algeria' },
    { name: 'American Samoa', value: 'American Samoa' },
    { name: 'Andorra', value: 'Andorra' },
    { name: 'Angola', value: 'Angola' },
    { name: 'Anguilla', value: 'Anguilla' },
    { name: 'Antigua and Barbuda', value: 'Antigua and Barbuda' },
    { name: 'Argentina', value: 'Argentina' },
    { name: 'Armenia', value: 'Armenia' },
    { name: 'Aruba', value: 'Aruba' },
    { name: 'Australia', value: 'Australia' },
    { name: 'Austria', value: 'Austria' },
    { name: 'Azerbaijan', value: 'Azerbaijan' },
    { name: 'Bahamas', value: 'Bahamas' },
    { name: 'Bahrain', value: 'Bahrain' },
    { name: 'Bangladesh', value: 'Bangladesh' },
    { name: 'Barbados', value: 'Barbados' },
    { name: 'Belarus', value: 'Belarus' },
    { name: 'Belgium', value: 'Belgium' },
    { name: 'Belize', value: 'Belize' },
    { name: 'Benin', value: 'Benin' },
    { name: 'Bermuda', value: 'Bermuda' },
    { name: 'Bhutan', value: 'Bhutan' },
    { name: 'Bolivia', value: 'Bolivia' },
    { name: 'Bosnia-Herzegovina', value: 'Bosnia-Herzegovina' },
    { name: 'Botswana', value: 'Botswana' },
    { name: 'Brazil', value: 'Brazil' },
    { name: 'British Indian Ocean Territory', value: 'British Indian Ocean Territory' },
    { name: 'Brunei', value: 'Brunei' },
    { name: 'Bulgaria', value: 'Bulgaria' },
    { name: 'Burkina Faso', value: 'Burkina Faso' },
    { name: 'Burma', value: 'Burma' },
    { name: 'Burundi', value: 'Burundi' },
    { name: 'Cambodia', value: 'Cambodia' },
    { name: 'Cameroon', value: 'Cameroon' },
    { name: 'Canada', value: 'Canada' },
    { name: 'Canton and Enderbury Islands', value: 'Canton and Enderbury Islands' },
    { name: 'Cape Verde', value: 'Cape Verde' },
    { name: 'Cayman Islands', value: 'Cayman Islands' },
    { name: 'Central African Republic', value: 'Central African Republic' },
    { name: 'Chad', value: 'Chad' },
    { name: 'Chile', value: 'Chile' },
    { name: 'China', value: 'China' },
    { name: 'Christmas Island', value: 'Christmas Island' },
    { name: 'Cocos (Keeling) Islands', value: 'Cocos (Keeling) Islands' },
    { name: 'Colombia', value: 'Colombia' },
    { name: 'Comoros', value: 'Comoros' },
    { name: 'Congo', value: 'Congo' },
    { name: 'Congo, Democratic Republic', value: 'Congo, Democratic Republic' },
    { name: 'Cook Islands', value: 'Cook Islands' },
    { name: 'Costa Rica', value: 'Costa Rica' },
    { name: 'Côte d’Ivoire', value: 'Côte d’Ivoire' },
    { name: 'Croatia', value: 'Croatia' },
    { name: 'Cuba', value: 'Cuba' },
    { name: 'Curaçao', value: 'Curaçao' },
    { name: 'Cyprus', value: 'Cyprus' },
    { name: 'Czech Republic', value: 'Czech Republic' },
    { name: 'Denmark', value: 'Denmark' },
    { name: 'Djibouti', value: 'Djibouti' },
    { name: 'Dominica', value: 'Dominica' },
    { name: 'Dominican Republic', value: 'Dominican Republic' },
    { name: 'Dronning Maud Land', value: 'Dronning Maud Land' },
    { name: 'East Timor', value: 'East Timor' },
    { name: 'Ecuador', value: 'Ecuador' },
    { name: 'Egypt', value: 'Egypt' },
    { name: 'El Salvador', value: 'El Salvador' },
    { name: 'Equatorial Guinea', value: 'Equatorial Guinea' },
    { name: 'Eritrea', value: 'Eritrea' },
    { name: 'Estonia', value: 'Estonia' },
    { name: 'Ethiopia', value: 'Ethiopia' },
    { name: 'Faeroe Islands (Føroyar)', value: 'Faeroe Islands (Føroyar)' },
    { name: 'Falkland Islands', value: 'Falkland Islands' },
    { name: 'Fiji', value: 'Fiji' },
    { name: 'Finland', value: 'Finland' },
    { name: 'France', value: 'France' },
    { name: 'French Guiana', value: 'French Guiana' },
    { name: 'French Polynesia', value: 'French Polynesia' },
    { name: 'Gabon', value: 'Gabon' },
    { name: 'Gambia', value: 'Gambia' },
    { name: 'Georgia', value: 'Georgia' },
    { name: 'Germany', value: 'Germany' },
    { name: 'Ghana', value: 'Ghana' },
    { name: 'Gibraltar', value: 'Gibraltar' },
    { name: 'Great Britain', value: 'Great Britain' },
    { name: 'Greece', value: 'Greece' },
    { name: 'Greenland', value: 'Greenland' },
    { name: 'Grenada', value: 'Grenada' },
    { name: 'Guadeloupe', value: 'Guadeloupe' },
    { name: 'Guam', value: 'Guam' },
    { name: 'Guatemala', value: 'Guatemala' },
    { name: 'Guernsey', value: 'Guernsey' },
    { name: 'Guinea', value: 'Guinea' },
    { name: 'Guinea-Bissau', value: 'Guinea-Bissau' },
    { name: 'Guyana', value: 'Guyana' },
    { name: 'Haiti', value: 'Haiti' },
    { name: 'Heard and McDonald Islands', value: 'Heard and McDonald Islands' },
    { name: 'Honduras', value: 'Honduras' },
    { name: 'Hong Kong', value: 'Hong Kong' },
    { name: 'Hungary', value: 'Hungary' },
    { name: 'Iceland', value: 'Iceland' },
    { name: 'India', value: 'India' },
    { name: 'Indonesia', value: 'Indonesia' },
    { name: 'International Monetary Fund', value: 'International Monetary Fund' },
    { name: 'Iran', value: 'Iran' },
    { name: 'Iraq', value: 'Iraq' },
    { name: 'Ireland', value: 'Ireland' },
    { name: 'Isle of Man', value: 'Isle of Man' },
    { name: 'Israel', value: 'Israel' },
    { name: 'Italy', value: 'Italy' },
    { name: 'Ivory Coast', value: 'Ivory Coast' },
    { name: 'Jamaica', value: 'Jamaica' },
    { name: 'Japan', value: 'Japan' },
    { name: 'Jersey', value: 'Jersey' },
    { name: 'Johnston Island', value: 'Johnston Island' },
    { name: 'Jordan', value: 'Jordan' },
    { name: 'Kampuchea', value: 'Kampuchea' },
    { name: 'Kazakhstan', value: 'Kazakhstan' },
    { name: 'Kenya', value: 'Kenya' },
    { name: 'Kiribati', value: 'Kiribati' },
    { name: 'Korea, North', value: 'Korea, North' },
    { name: 'Korea, South', value: 'Korea, South' },
    { name: 'Kuwait', value: 'Kuwait' },
    { name: 'Kyrgyzstan', value: 'Kyrgyzstan' },
    { name: 'Laos', value: 'Laos' },
    { name: 'Latvia', value: 'Latvia' },
    { name: 'Lebanon', value: 'Lebanon' },
    { name: 'Lesotho', value: 'Lesotho' },
    { name: 'Liberia', value: 'Liberia' },
    { name: 'Libya', value: 'Libya' },
    { name: 'Liechtenstein', value: 'Liechtenstein' },
    { name: 'Lithuania', value: 'Lithuania' },
    { name: 'Luxembourg', value: 'Luxembourg' },
    { name: 'Macau', value: 'Macau' },
    { name: 'Macedonia (Former Yug. Rep.)', value: 'Macedonia (Former Yug. Rep.)' },
    { name: 'Madagascar', value: 'Madagascar' },
    { name: 'Malawi', value: 'Malawi' },
    { name: 'Malaysia', value: 'Malaysia' },
    { name: 'Maldives', value: 'Maldives' },
    { name: 'Mali', value: 'Mali' },
    { name: 'Malta', value: 'Malta' },
    { name: 'Marshall Islands', value: 'Marshall Islands' },
    { name: 'Martinique', value: 'Martinique' },
    { name: 'Mauritania', value: 'Mauritania' },
    { name: 'Mauritius', value: 'Mauritius' },
    { name: 'Mayotte', value: 'Mayotte' },
    { name: 'Mexico', value: 'Mexico' },
    { name: 'Micronesia', value: 'Micronesia' },
    { name: 'Midway Islands', value: 'Midway Islands' },
    { name: 'Moldova', value: 'Moldova' },
    { name: 'Monaco', value: 'Monaco' },
    { name: 'Mongolia', value: 'Mongolia' },
    { name: 'Montenegro', value: 'Montenegro' },
    { name: 'Montserrat', value: 'Montserrat' },
    { name: 'Morocco', value: 'Morocco' },
    { name: 'Mozambique', value: 'Mozambique' },
    { name: 'Myanmar', value: 'Myanmar' },
    { name: 'Namibia', value: 'Namibia' },
    { name: 'Nauru', value: 'Nauru' },
    { name: 'Nepal', value: 'Nepal' },
    { name: 'Netherlands', value: 'Netherlands' },
    { name: 'Netherlands Antilles', value: 'Netherlands Antilles' },
    { name: 'New Caledonia', value: 'New Caledonia' },
    { name: 'New Zealand', value: 'New Zealand' },
    { name: 'Nicaragua', value: 'Nicaragua' },
    { name: 'Niger', value: 'Niger' },
    { name: 'Nigeria', value: 'Nigeria' },
    { name: 'Niue', value: 'Niue' },
    { name: 'Norfolk Island', value: 'Norfolk Island' },
    { name: 'Northern Mariana Islands', value: 'Northern Mariana Islands' },
    { name: 'Norway', value: 'Norway' },
    { name: 'Oman', value: 'Oman' },
    { name: 'Pakistan', value: 'Pakistan' },
    { name: 'Palau', value: 'Palau' },
    { name: 'Palestine', value: 'Palestine' },
    { name: 'Panama', value: 'Panama' },
    { name: 'Papua New Guinea', value: 'Papua New Guinea' },
    { name: 'Paraguay', value: 'Paraguay' },
    { name: 'Peru', value: 'Peru' },
    { name: 'Philippines', value: 'Philippines' },
    { name: 'Pitcairn Island', value: 'Pitcairn Island' },
    { name: 'Poland', value: 'Poland' },
    { name: 'Portugal', value: 'Portugal' },
    { name: 'Puerto Rico', value: 'Puerto Rico' },
    { name: 'Qatar', value: 'Qatar' },
    { name: 'Reunion', value: 'Reunion' },
    { name: 'Romania', value: 'Romania' },
    { name: 'Russia', value: 'Russia' },
    { name: 'Rwanda', value: 'Rwanda' },
    { name: 'Samoa (America)', value: 'Samoa (America)' },
    { name: 'Samoa (Western)', value: 'Samoa (Western)' },
    { name: 'San Marino', value: 'San Marino' },
    { name: 'São Tomé and Príncipe', value: 'São Tomé and Príncipe' },
    { name: 'Saudi Arabia', value: 'Saudi Arabia' },
    { name: 'Sénégal', value: 'Sénégal' },
    { name: 'Serbia', value: 'Serbia' },
    { name: 'Seychelles', value: 'Seychelles' },
    { name: 'Sierra Leone', value: 'Sierra Leone' },
    { name: 'Singapore', value: 'Singapore' },
    { name: 'Slovakia', value: 'Slovakia' },
    { name: 'Slovenia', value: 'Slovenia' },
    { name: 'Solomon Islands', value: 'Solomon Islands' },
    { name: 'Somalia', value: 'Somalia' },
    { name: 'South Africa', value: 'South Africa' },
    { name: 'Spain', value: 'Spain' },
    { name: 'Sri Lanka', value: 'Sri Lanka' },
    { name: 'St. Helena', value: 'St. Helena' },
    { name: 'St. Kitts and Nevis', value: 'St. Kitts and Nevis' },
    { name: 'St. Lucia', value: 'St. Lucia' },
    { name: 'St. Vincent and the Grenadines', value: 'St. Vincent and the Grenadines' },
    { name: 'Sudan', value: 'Sudan' },
    { name: 'Suriname', value: 'Suriname' },
    { name: 'Svalbard and Jan Mayen Islands', value: 'Svalbard and Jan Mayen Islands' },
    { name: 'Swaziland', value: 'Swaziland' },
    { name: 'Sweden', value: 'Sweden' },
    { name: 'Switzerland', value: 'Switzerland' },
    { name: 'Syria', value: 'Syria' },
    { name: 'Tahiti', value: 'Tahiti' },
    { name: 'Taiwan', value: 'Taiwan' },
    { name: 'Tajikistan', value: 'Tajikistan' },
    { name: 'Tanzania', value: 'Tanzania' },
    { name: 'Thailand', value: 'Thailand' },
    { name: 'Timor-Leste', value: 'Timor-Leste' },
    { name: 'Togo', value: 'Togo' },
    { name: 'Trinidad and Tobago', value: 'Trinidad and Tobago' },
    { name: 'Tunisia', value: 'Tunisia' },
    { name: 'Turkey', value: 'Turkey' },
    { name: 'Turkmenistan', value: 'Turkmenistan' },
    { name: 'Turks and Caicos Islands', value: 'Turks and Caicos Islands' },
    { name: 'Tuvalu', value: 'Tuvalu' },
    { name: 'Uganda', value: 'Uganda' },
    { name: 'United KingdomK', value: 'UK' },
    { name: 'Ukraine', value: 'Ukraine' },
    { name: 'United Arab Emirates', value: 'United Arab Emirates' },
    { name: 'United States', value: 'United States' },
    { name: 'Upper Volta', value: 'Upper Volta' },
    { name: 'Uruguay', value: 'Uruguay' },
    { name: 'Uzbekistan', value: 'Uzbekistan' },
    { name: 'Vanuatu', value: 'Vanuatu' },
    { name: 'Vatican', value: 'Vatican' },
    { name: 'Venezuela', value: 'Venezuela' },
    { name: 'Vietnam', value: 'Vietnam' },
    { name: 'Virgin Islands', value: 'Virgin Islands' },
    { name: 'Wake Island', value: 'Wake Island' },
    { name: 'Wallis and Futuna Islands', value: 'Wallis and Futuna Islands' },
    { name: 'Western Sahara', value: 'Western Sahara' },
    { name: 'Western Samoa', value: 'Western Samoa' },
    { name: 'Yemen', value: 'Yemen' },
    { name: 'Zaïre', value: 'Zaïre' },
    { name: 'Zambia', value: 'Zambia' },
    { name: 'Zimbabwe', value: 'Zimbabwe' }
];

export const countries_pt_payment: Countries [] = [
    { name: 'Afeganistão', value: 'Afghanistan' },
    { name: 'África do Sul', value: 'South Africa' },
    { name: 'Albânia', value: 'Albania' },
    { name: 'Alemanha', value: 'Germany' },
    { name: 'Alto Volta', value: 'Upper Volta' },
    { name: 'Andorra', value: 'Andorra' },
    { name: 'Angola', value: 'Angola' },
    { name: 'Anguila', value: 'Anguilla' },
    { name: 'Antígua e Barbuda', value: 'Antigua and Barbuda' },
    { name: 'Antilhas Holandesas', value: 'Netherlands Antilles' },
    { name: 'Arábia Saudita', value: 'Saudi Arabia' },
    { name: 'Argélia', value: 'Algeria' },
    { name: 'Argentina', value: 'Argentina' },
    { name: 'Arménia', value: 'Armenia' },
    { name: 'Aruba', value: 'Aruba' },
    { name: 'Austrália', value: 'Australia' },
    { name: 'Áustria', value: 'Austria' },
    { name: 'Azerbaijão', value: 'Azerbaijan' },
    { name: 'Bahamas', value: 'Bahamas' },
    { name: 'Bahrein', value: 'Bahrain' },
    { name: 'Bangladeche', value: 'Bangladesh' },
    { name: 'Barbados', value: 'Barbados' },
    { name: 'Bélgica', value: 'Belgium' },
    { name: 'Belize', value: 'Belize' },
    { name: 'Benim', value: 'Benin' },
    { name: 'Bermudas', value: 'Bermuda' },
    { name: 'Bielorrússia', value: 'Belarus' },
    { name: 'Birmânia', value: 'Burma' },
    { name: 'Bolívia', value: 'Bolivia' },
    { name: 'Bósnia-Herzegovina', value: 'Bosnia-Herzegovina' },
    { name: 'Botsuana', value: 'Botswana' },
    { name: 'Brasil', value: 'Brazil' },
    { name: 'Brunei', value: 'Brunei' },
    { name: 'Bulgária', value: 'Bulgaria' },
    { name: 'Burkina Faso', value: 'Burkina Faso' },
    { name: 'Burundi', value: 'Burundi' },
    { name: 'Butão', value: 'Bhutan' },
    { name: 'Cabo Verde', value: 'Cape Verde' },
    { name: 'Camarões', value: 'Cameroon' },
    { name: 'Camboja', value: 'Cambodia' },
    { name: 'Canadá', value: 'Canada' },
    { name: 'Cantão e Ilhas Enderbury', value: 'Canton and Enderbury Islands' },
    { name: 'Cazaquistão', value: 'Kazakhstan' },
    { name: 'Chade', value: 'Chad' },
    { name: 'Chile', value: 'Chile' },
    { name: 'China', value: 'China' },
    { name: 'Chipre', value: 'Cyprus' },
    { name: 'Colômbia', value: 'Colombia' },
    { name: 'Comores', value: 'Comoros' },
    { name: 'Congo', value: 'Congo' },
    { name: 'Congo, República Democrática', value: 'Congo, Democratic Republic' },
    { name: 'Coreia do Norte', value: 'Korea, North' },
    { name: 'Coreia do Sul', value: 'Korea, South' },
    { name: 'Costa do Marfim', value: 'Côte d’Ivoire' },
    { name: 'Costa Rica', value: 'Costa Rica' },
    { name: 'Croácia', value: 'Croatia' },
    { name: 'Cuba', value: 'Cuba' },
    { name: 'Curaçao', value: 'Curaçao' },
    { name: 'Dinamarca', value: 'Denmark' },
    { name: 'Djibouti', value: 'Djibouti' },
    { name: 'Domínica', value: 'Dominica' },
    { name: 'Dronning Maud Land', value: 'Dronning Maud Land' },
    { name: 'Egipto', value: 'Egypt' },
    { name: 'El Salvador', value: 'El Salvador' },
    { name: 'Emirados Árabes Unidos', value: 'United Arab Emirates' },
    { name: 'Equador', value: 'Ecuador' },
    { name: 'Eritreia', value: 'Eritrea' },
    { name: 'Eslováquia', value: 'Slovakia' },
    { name: 'Eslovénia', value: 'Slovenia' },
    { name: 'Espanha', value: 'Spain' },
    { name: 'Estados Unidos da América', value: 'United States' },
    { name: 'Estónia', value: 'Estonia' },
    { name: 'Etiópia', value: 'Ethiopia' },
    { name: 'Fiji', value: 'Fiji' },
    { name: 'Filipinas', value: 'Philippines' },
    { name: 'Finlândia', value: 'Finland' },
    { name: 'França', value: 'France' },
    { name: 'Fundo Monetário Internacional', value: 'International Monetary Fund' },
    { name: 'Gabão', value: 'Gabon' },
    { name: 'Gâmbia', value: 'Gambia' },
    { name: 'Gana', value: 'Ghana' },
    { name: 'Geórgia', value: 'Georgia' },
    { name: 'Gibraltar', value: 'Gibraltar' },
    { name: 'Grã-Bretanha', value: 'Great Britain' },
    { name: 'Grécia', value: 'Greece' },
    { name: 'Grenada', value: 'Grenada' },
    { name: 'Gronelândia', value: 'Greenland' },
    { name: 'Guadalupe', value: 'Guadeloupe' },
    { name: 'Guam', value: 'Guam' },
    { name: 'Guatemala', value: 'Guatemala' },
    { name: 'Guernsey', value: 'Guernsey' },
    { name: 'Guiana', value: 'Guyana' },
    { name: 'Guiana Francesa', value: 'French Guiana' },
    { name: 'Guiné', value: 'Guinea' },
    { name: 'Guiné Equatorial', value: 'Equatorial Guinea' },
    { name: 'Guiné-Bissau', value: 'Guinea-Bissau' },
    { name: 'Haiti', value: 'Haiti' },
    { name: 'Heard e McDonald Islands', value: 'Heard and McDonald Islands' },
    { name: 'Honduras', value: 'Honduras' },
    { name: 'Hong Kong', value: 'Hong Kong' },
    { name: 'Hungria', value: 'Hungary' },
    { name: 'Iémen', value: 'Yemen' },
    { name: 'Ilha de Man', value: 'Isle of Man' },
    { name: 'Ilha de Natal', value: 'Christmas Island' },
    { name: 'Ilha de Norfolk', value: 'Norfolk Island' },
    { name: 'Ilha Johnston', value: 'Johnston Island' },
    { name: 'Ilha Pitcairn', value: 'Pitcairn Island' },
    { name: 'Ilhas Caimão', value: 'Cayman Islands' },
    { name: 'Ilhas Cocos (Keeling)', value: 'Cocos (Keeling) Islands' },
    { name: 'Ilhas Cook', value: 'Cook Islands' },
    { name: 'Ilhas Faroé (Føroyar)', value: 'Faeroe Islands (Føroyar)' },
    { name: 'Ilhas Malvinas', value: 'Falkland Islands' },
    { name: 'Ilhas Marianas do Norte', value: 'Northern Mariana Islands' },
    { name: 'Ilhas Marshall', value: 'Marshall Islands' },
    { name: 'Ilhas Midway', value: 'Midway Islands' },
    { name: 'Ilhas Salomão', value: 'Solomon Islands' },
    { name: 'Ilhas Svalbard e Jan Mayen', value: 'Svalbard and Jan Mayen Islands' },
    { name: 'Ilhas Turcas e Caicos', value: 'Turks and Caicos Islands' },
    { name: 'Ilhas Virgens', value: 'Virgin Islands' },
    { name: 'Ilhas Wallis e Futuna', value: 'Wallis and Futuna Islands' },
    { name: 'Índia', value: 'India' },
    { name: 'Indonésia', value: 'Indonesia' },
    { name: 'Irão', value: 'Iran' },
    { name: 'Iraque', value: 'Iraq' },
    { name: 'Irlanda', value: 'Ireland' },
    { name: 'Islândia', value: 'Iceland' },
    { name: 'Israel', value: 'Israel' },
    { name: 'Itália', value: 'Italy' },
    { name: 'Jamaica', value: 'Jamaica' },
    { name: 'Japão', value: 'Japan' },
    { name: 'Jersey', value: 'Jersey' },
    { name: 'Jordânia', value: 'Jordan' },
    { name: 'Kampuchea', value: 'Kampuchea' },
    { name: 'Kiribati', value: 'Kiribati' },
    { name: 'Kuwait', value: 'Kuwait' },
    { name: 'Laos', value: 'Laos' },
    { name: 'Lesotho', value: 'Lesotho' },
    { name: 'Letónia', value: 'Latvia' },
    { name: 'Líbano', value: 'Lebanon' },
    { name: 'Libéria', value: 'Liberia' },
    { name: 'Líbia', value: 'Libya' },
    { name: 'Liechtenstein', value: 'Liechtenstein' },
    { name: 'Lituânia', value: 'Lithuania' },
    { name: 'Luxemburgo', value: 'Luxembourg' },
    { name: 'Macau', value: 'Macau' },
    { name: 'Macedónia (antigo Rep. Yug.)', value: 'Macedonia (Former Yug. Rep.)' },
    { name: 'Madagáscar', value: 'Madagascar' },
    { name: 'Malásia', value: 'Malaysia' },
    { name: 'Malawi', value: 'Malawi' },
    { name: 'Maldivas', value: 'Maldives' },
    { name: 'Mali', value: 'Mali' },
    { name: 'Malta', value: 'Malta' },
    { name: 'Marrocos', value: 'Morocco' },
    { name: 'Martinica', value: 'Martinique' },
    { name: 'Maurícia', value: 'Mauritius' },
    { name: 'Mauritânia', value: 'Mauritania' },
    { name: 'Mayotte', value: 'Mayotte' },
    { name: 'México', value: 'Mexico' },
    { name: 'Micronésia', value: 'Micronesia' },
    { name: 'Moçambique', value: 'Mozambique' },
    { name: 'Moldávia', value: 'Moldova' },
    { name: 'Mónaco', value: 'Monaco' },
    { name: 'Mongólia', value: 'Mongolia' },
    { name: 'Montenegro', value: 'Montenegro' },
    { name: 'Montserrat', value: 'Montserrat' },
    { name: 'Myanmar', value: 'Myanmar' },
    { name: 'Namíbia', value: 'Namibia' },
    { name: 'Nauru', value: 'Nauru' },
    { name: 'Nepal', value: 'Nepal' },
    { name: 'Nicarágua', value: 'Nicaragua' },
    { name: 'Níger', value: 'Niger' },
    { name: 'Nigéria', value: 'Nigeria' },
    { name: 'Niue', value: 'Niue' },
    { name: 'Noruega', value: 'Norway' },
    { name: 'Nova Caledónia', value: 'New Caledonia' },
    { name: 'Nova Zelândia', value: 'New Zealand' },
    { name: 'Omã', value: 'Oman' },
    { name: 'Países Baixos', value: 'Netherlands' },
    { name: 'Palau', value: 'Palau' },
    { name: 'Palestina', value: 'Palestine' },
    { name: 'Panamá', value: 'Panama' },
    { name: 'Papua Nova Guiné', value: 'Papua New Guinea' },
    { name: 'Paquistão', value: 'Pakistan' },
    { name: 'Paraguai', value: 'Paraguay' },
    { name: 'Peru', value: 'Peru' },
    { name: 'Polinésia Francesa', value: 'French Polynesia' },
    { name: 'Polónia', value: 'Poland' },
    { name: 'Porto Rico', value: 'Puerto Rico' },
    { name: 'Portugal', value: 'Portugal' },
    { name: 'Qatar', value: 'Qatar' },
    { name: 'Quénia', value: 'Kenya' },
    { name: 'Quirguizistão', value: 'Kyrgyzstan' },
    { name: 'Reino Unido', value: 'UK' },
    { name: 'República Centro-Africana', value: 'Central African Republic' },
    { name: 'República Checa', value: 'Czech Republic' },
    { name: 'República Dominicana', value: 'Dominican Republic' },
    { name: 'Reunião', value: 'Reunion' },
    { name: 'Roménia', value: 'Romania' },
    { name: 'Ruanda', value: 'Rwanda' },
    { name: 'Rússia', value: 'Russia' },
    { name: 'Samoa (América)', value: 'Samoa (America)' },
    { name: 'Samoa (Ocidental)', value: 'Samoa (Western)' },
    { name: 'Santa Helena', value: 'St. Helena' },
    { name: 'Santa Lúcia', value: 'St. Lucia' },
    { name: 'São Marino', value: 'San Marino' },
    { name: 'São Tomé e Príncipe', value: 'São Tomé and Príncipe' },
    { name: 'São Vicente e as Granadinas', value: 'St. Vincent and the Grenadines' },
    { name: 'Sara Ocidental', value: 'Western Sahara' },
    { name: 'Sénégal', value: 'Sénégal' },
    { name: 'Serra Leoa', value: 'Sierra Leone' },
    { name: 'Sérvia', value: 'Serbia' },
    { name: 'Seychelles', value: 'Seychelles' },
    { name: 'Singapura', value: 'Singapore' },
    { name: 'Síria', value: 'Syria' },
    { name: 'Somália', value: 'Somalia' },
    { name: 'Sri Lanka', value: 'Sri Lanka' },
    { name: 'St. Kitts e Nevis', value: 'St. Kitts and Nevis' },
    { name: 'Suazilândia', value: 'Swaziland' },
    { name: 'Sudão', value: 'Sudan' },
    { name: 'Suécia', value: 'Sweden' },
    { name: 'Suíça', value: 'Switzerland' },
    { name: 'Suriname', value: 'Suriname' },
    { name: 'Tahiti', value: 'Tahiti' },
    { name: 'Tailândia', value: 'Thailand' },
    { name: 'Taiwan', value: 'Taiwan' },
    { name: 'Tajiquistão', value: 'Tajikistan' },
    { name: 'Tanzânia', value: 'Tanzania' },
    { name: 'Território Britânico do Oceano Índico', value: 'British Indian Ocean Territory' },
    { name: 'Timor-Leste', value: 'Timor-Leste' },
    { name: 'Togo', value: 'Togo' },
    { name: 'Trindade e Tobago', value: 'Trinidad and Tobago' },
    { name: 'Tunísia', value: 'Tunisia' },
    { name: 'Turquemenistão', value: 'Turkmenistan' },
    { name: 'Turquia', value: 'Turkey' },
    { name: 'Tuvalu', value: 'Tuvalu' },
    { name: 'Ucrânia', value: 'Ukraine' },
    { name: 'Uganda', value: 'Uganda' },
    { name: 'Uruguai', value: 'Uruguay' },
    { name: 'Uzbequistão', value: 'Uzbekistan' },
    { name: 'Vanuatu', value: 'Vanuatu' },
    { name: 'Vaticano', value: 'Vatican' },
    { name: 'Venezuela', value: 'Venezuela' },
    { name: 'Vietname', value: 'Vietnam' },
    { name: 'Wake Island', value: 'Wake Island' },
    { name: 'Zaïre', value: 'Zaïre' },
    { name: 'Zâmbia', value: 'Zambia' },
    { name: 'Zimbabué', value: 'Zimbabwe' }
];

export const countries_es_payment: Countries [] = [
    { name: 'Afganistán', value: 'Afghanistan' },
    { name: 'Albania', value: 'Albania' },
    { name: 'Alemania', value: 'Germany' },
    { name: 'Alto Volta', value: 'Upper Volta' },
    { name: 'Andorra', value: 'Andorra' },
    { name: 'Angola', value: 'Angola' },
    { name: 'Anguila', value: 'Anguilla' },
    { name: 'Antigua y Barbuda', value: 'Antigua and Barbuda' },
    { name: 'Antillas Neerlandesas', value: 'Netherlands Antilles' },
    { name: 'Arabia Saudí', value: 'Saudi Arabia' },
    { name: 'Argelia', value: 'Algeria' },
    { name: 'Argentina', value: 'Argentina' },
    { name: 'Armenia', value: 'Armenia' },
    { name: 'Aruba', value: 'Aruba' },
    { name: 'Australia', value: 'Australia' },
    { name: 'Austria', value: 'Austria' },
    { name: 'Azerbaiyán', value: 'Azerbaijan' },
    { name: 'Bahamas', value: 'Bahamas' },
    { name: 'Bahréin', value: 'Bahrain' },
    { name: 'Bangladesh', value: 'Bangladesh' },
    { name: 'Barbados', value: 'Barbados' },
    { name: 'Bélgica', value: 'Belgium' },
    { name: 'Belice', value: 'Belize' },
    { name: 'Benín', value: 'Benin' },
    { name: 'Bermudas', value: 'Bermuda' },
    { name: 'Bielorrusia', value: 'Belarus' },
    { name: 'Birmania', value: 'Burma' },
    { name: 'Bolivia', value: 'Bolivia' },
    { name: 'Bosnia-Herzegovina', value: 'Bosnia-Herzegovina' },
    { name: 'Botsuana', value: 'Botswana' },
    { name: 'Brasil', value: 'Brazil' },
    { name: 'Brunei', value: 'Brunei' },
    { name: 'Bulgaria', value: 'Bulgaria' },
    { name: 'Burkina Faso', value: 'Burkina Faso' },
    { name: 'Burundi', value: 'Burundi' },
    { name: 'Bután', value: 'Bhutan' },
    { name: 'Cabo Verde', value: 'Cape Verde' },
    { name: 'Camboya', value: 'Cambodia' },
    { name: 'Camerún', value: 'Cameroon' },
    { name: 'Canadá', value: 'Canada' },
    { name: 'Cantón e Islas Enderbury', value: 'Canton and Enderbury Islands' },
    { name: 'Chad', value: 'Chad' },
    { name: 'Chile', value: 'Chile' },
    { name: 'China', value: 'China' },
    { name: 'Chipre', value: 'Cyprus' },
    { name: 'Colombia', value: 'Colombia' },
    { name: 'Comoras', value: 'Comoros' },
    { name: 'Congo', value: 'Congo' },
    { name: 'Congo, República Democrática', value: 'Congo, Democratic Republic' },
    { name: 'Corea del Norte', value: 'Korea, North' },
    { name: 'Corea del Sur', value: 'Korea, South' },
    { name: 'Costa de Marfil', value: 'Côte d’Ivoire' },
    { name: 'Costa Rica', value: 'Costa Rica' },
    { name: 'Croacia', value: 'Croatia' },
    { name: 'Cuba', value: 'Cuba' },
    { name: 'Curaçao', value: 'Curaçao' },
    { name: 'Dinamarca', value: 'Denmark' },
    { name: 'Dominica', value: 'Dominica' },
    { name: 'Dronning Maud Land', value: 'Dronning Maud Land' },
    { name: 'Ecuador', value: 'Ecuador' },
    { name: 'Egipto', value: 'Egypt' },
    { name: 'El Salvador', value: 'El Salvador' },
    { name: 'Emiratos Árabes Unidos', value: 'United Arab Emirates' },
    { name: 'Eritrea', value: 'Eritrea' },
    { name: 'Eslovaquia', value: 'Slovakia' },
    { name: 'Eslovenia', value: 'Slovenia' },
    { name: 'España', value: 'Spain' },
    { name: 'Estados Unidos', value: 'United States' },
    { name: 'Estonia', value: 'Estonia' },
    { name: 'Etiopía', value: 'Ethiopia' },
    { name: 'Falkland Islands (Islas Malvinas)', value: 'Falkland Islands' },
    { name: 'Filipinas', value: 'Philippines' },
    { name: 'Finlandia', value: 'Finland' },
    { name: 'Fiyi', value: 'Fiji' },
    { name: 'Fondo Monetario Internacional', value: 'International Monetary Fund' },
    { name: 'Francia', value: 'France' },
    { name: 'Gabón', value: 'Gabon' },
    { name: 'Gambia', value: 'Gambia' },
    { name: 'Georgia', value: 'Georgia' },
    { name: 'Ghana', value: 'Ghana' },
    { name: 'Gibraltar', value: 'Gibraltar' },
    { name: 'Gran Bretaña', value: 'Great Britain' },
    { name: 'Granada', value: 'Grenada' },
    { name: 'Grecia', value: 'Greece' },
    { name: 'Groenlandia', value: 'Greenland' },
    { name: 'Guadalupe', value: 'Guadeloupe' },
    { name: 'Guam', value: 'Guam' },
    { name: 'Guatemala', value: 'Guatemala' },
    { name: 'Guayana Francesa', value: 'French Guiana' },
    { name: 'Guernesey', value: 'Guernsey' },
    { name: 'Guinea', value: 'Guinea' },
    { name: 'Guinea Ecuatorial', value: 'Equatorial Guinea' },
    { name: 'Guinea-Bissau', value: 'Guinea-Bissau' },
    { name: 'Guyana', value: 'Guyana' },
    { name: 'Haití', value: 'Haiti' },
    { name: 'Honduras', value: 'Honduras' },
    { name: 'Hong Kong', value: 'Hong Kong' },
    { name: 'Hungría', value: 'Hungary' },
    { name: 'India', value: 'India' },
    { name: 'Indonesia', value: 'Indonesia' },
    { name: 'Irán', value: 'Iran' },
    { name: 'Iraq', value: 'Iraq' },
    { name: 'Irlanda', value: 'Ireland' },
    { name: 'Isla de Johnston', value: 'Johnston Island' },
    { name: 'Isla de Man', value: 'Isle of Man' },
    { name: 'Isla de Navidad', value: 'Christmas Island' },
    { name: 'Isla Norfolk', value: 'Norfolk Island' },
    { name: 'Isla Pitcairn', value: 'Pitcairn Island' },
    { name: 'Islandia', value: 'Iceland' },
    { name: 'Islas Caimán', value: 'Cayman Islands' },
    { name: 'Islas Cocos (Keeling)', value: 'Cocos (Keeling) Islands' },
    { name: 'Islas Cook', value: 'Cook Islands' },
    { name: 'Islas Feroe (Føroyar)', value: 'Faeroe Islands (Føroyar)' },
    { name: 'Islas Heard y McDonald', value: 'Heard and McDonald Islands' },
    { name: 'Islas Marianas del Norte', value: 'Northern Mariana Islands' },
    { name: 'Islas Marshall', value: 'Marshall Islands' },
    { name: 'Islas Midway', value: 'Midway Islands' },
    { name: 'Islas Salomón', value: 'Solomon Islands' },
    { name: 'Islas Turcas y Caicos', value: 'Turks and Caicos Islands' },
    { name: 'Islas Vírgenes', value: 'Virgin Islands' },
    { name: 'Islas Wake', value: 'Wake Island' },
    { name: 'Islas Wallis y Futuna', value: 'Wallis and Futuna Islands' },
    { name: 'Israel', value: 'Israel' },
    { name: 'Italia', value: 'Italy' },
    { name: 'Jamaica', value: 'Jamaica' },
    { name: 'Japón', value: 'Japan' },
    { name: 'Jersey', value: 'Jersey' },
    { name: 'Jordania', value: 'Jordan' },
    { name: 'Kampuchea', value: 'Kampuchea' },
    { name: 'Kazajstán', value: 'Kazakhstan' },
    { name: 'Kenia', value: 'Kenya' },
    { name: 'Kirguistán', value: 'Kyrgyzstan' },
    { name: 'Kiribati', value: 'Kiribati' },
    { name: 'Kuwait', value: 'Kuwait' },
    { name: 'Laos', value: 'Laos' },
    { name: 'Lesotho', value: 'Lesotho' },
    { name: 'Letonia', value: 'Latvia' },
    { name: 'Líbano', value: 'Lebanon' },
    { name: 'Liberia', value: 'Liberia' },
    { name: 'Libia', value: 'Libya' },
    { name: 'Liechtenstein', value: 'Liechtenstein' },
    { name: 'Lituania', value: 'Lithuania' },
    { name: 'Luxemburgo', value: 'Luxembourg' },
    { name: 'Macao', value: 'Macau' },
    { name: 'Macedonia (Antigua Rep. Yugoslava)', value: 'Macedonia (Former Yug. Rep.)' },
    { name: 'Madagascar', value: 'Madagascar' },
    { name: 'Malasia', value: 'Malaysia' },
    { name: 'Malawi', value: 'Malawi' },
    { name: 'Maldivas', value: 'Maldives' },
    { name: 'Malí', value: 'Mali' },
    { name: 'Malta', value: 'Malta' },
    { name: 'Marruecos', value: 'Morocco' },
    { name: 'Martinica', value: 'Martinique' },
    { name: 'Mauricio', value: 'Mauritius' },
    { name: 'Mauritania', value: 'Mauritania' },
    { name: 'Mayotte', value: 'Mayotte' },
    { name: 'México', value: 'Mexico' },
    { name: 'Micronesia', value: 'Micronesia' },
    { name: 'Moldavia', value: 'Moldova' },
    { name: 'Mónaco', value: 'Monaco' },
    { name: 'Mongolia', value: 'Mongolia' },
    { name: 'Montenegro', value: 'Montenegro' },
    { name: 'Montserrat', value: 'Montserrat' },
    { name: 'Mozambique', value: 'Mozambique' },
    { name: 'Myanmar', value: 'Myanmar' },
    { name: 'Namibia', value: 'Namibia' },
    { name: 'Nauru', value: 'Nauru' },
    { name: 'Nepal', value: 'Nepal' },
    { name: 'Nicaragua', value: 'Nicaragua' },
    { name: 'Níger', value: 'Niger' },
    { name: 'Nigeria', value: 'Nigeria' },
    { name: 'Niue', value: 'Niue' },
    { name: 'Noruega', value: 'Norway' },
    { name: 'Nueva Caledonia', value: 'New Caledonia' },
    { name: 'Nueva Zelanda', value: 'New Zealand' },
    { name: 'Omán', value: 'Oman' },
    { name: 'Países Bajos', value: 'Netherlands' },
    { name: 'Pakistán', value: 'Pakistan' },
    { name: 'Palau', value: 'Palau' },
    { name: 'Palestina', value: 'Palestine' },
    { name: 'Panamá', value: 'Panama' },
    { name: 'Papúa Nueva Guinea', value: 'Papua New Guinea' },
    { name: 'Paraguay', value: 'Paraguay' },
    { name: 'Perú', value: 'Peru' },
    { name: 'Polinesia Francesa', value: 'French Polynesia' },
    { name: 'Polonia', value: 'Poland' },
    { name: 'Portugal', value: 'Portugal' },
    { name: 'Puerto Rico', value: 'Puerto Rico' },
    { name: 'Qatar', value: 'Qatar' },
    { name: 'Reino Unido', value: 'UK' },
    { name: 'República Centroafricana', value: 'Central African Republic' },
    { name: 'República Checa', value: 'Czech Republic' },
    { name: 'República Dominicana', value: 'Dominican Republic' },
    { name: 'Reunión', value: 'Reunion' },
    { name: 'Ruanda', value: 'Rwanda' },
    { name: 'Rumanía', value: 'Romania' },
    { name: 'Rusia', value: 'Russia' },
    { name: 'Sáhara Occidental', value: 'Western Sahara' },
    { name: 'Samoa (América)', value: 'Samoa (America)' },
    { name: 'Samoa (Occidental)', value: 'Samoa (Western)' },
    { name: 'San Cristóbal y Nieves', value: 'St. Kitts and Nevis' },
    { name: 'San Marino', value: 'San Marino' },
    { name: 'San Vicente y las Granadinas', value: 'St. Vincent and the Grenadines' },
    { name: 'Santa Helena', value: 'St. Helena' },
    { name: 'Santa Lucía', value: 'St. Lucia' },
    { name: 'Santo Tomé y Príncipe', value: 'São Tomé and Príncipe' },
    { name: 'Senegal', value: 'Sénégal' },
    { name: 'Serbia', value: 'Serbia' },
    { name: 'Seychelles', value: 'Seychelles' },
    { name: 'Sierra Leona', value: 'Sierra Leone' },
    { name: 'Singapur', value: 'Singapore' },
    { name: 'Siria', value: 'Syria' },
    { name: 'Somalia', value: 'Somalia' },
    { name: 'Sri Lanka', value: 'Sri Lanka' },
    { name: 'Suazilandia', value: 'Swaziland' },
    { name: 'Sudáfrica', value: 'South Africa' },
    { name: 'Sudán', value: 'Sudan' },
    { name: 'Suecia', value: 'Sweden' },
    { name: 'Suiza', value: 'Switzerland' },
    { name: 'Surinam', value: 'Suriname' },
    { name: 'Svalbard y Jan Mayen', value: 'Svalbard and Jan Mayen Islands' },
    { name: 'Tahití', value: 'Tahiti' },
    { name: 'Tailandia', value: 'Thailand' },
    { name: 'Taiwán', value: 'Taiwan' },
    { name: 'Tanzania', value: 'Tanzania' },
    { name: 'Tayikistán', value: 'Tajikistan' },
    { name: 'Territorio Británico del Océano Índico', value: 'British Indian Ocean Territory' },
    { name: 'Timor Oriental', value: 'Timor-Leste' },
    { name: 'Togo', value: 'Togo' },
    { name: 'Trinidad y Tobago', value: 'Trinidad and Tobago' },
    { name: 'Túnez', value: 'Tunisia' },
    { name: 'Turkmenistán', value: 'Turkmenistan' },
    { name: 'Turquía', value: 'Turkey' },
    { name: 'Tuvalu', value: 'Tuvalu' },
    { name: 'Ucrania', value: 'Ukraine' },
    { name: 'Uganda', value: 'Uganda' },
    { name: 'Uruguay', value: 'Uruguay' },
    { name: 'Uzbekistán', value: 'Uzbekistan' },
    { name: 'Vanuatu', value: 'Vanuatu' },
    { name: 'Vaticano', value: 'Vatican' },
    { name: 'Venezuela', value: 'Venezuela' },
    { name: 'Vietnam', value: 'Vietnam' },
    { name: 'Yemen', value: 'Yemen' },
    { name: 'Yibuti', value: 'Djibouti' },
    { name: 'Zaire', value: 'Zaïre' },
    { name: 'Zambia', value: 'Zambia' },
    { name: 'Zimbabue', value: 'Zimbabwe' }
];
